export enum PasswordResetType {
    Reset = 'reset',
}